/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { LemmonModal, useLocalization } from "@lemmonhq/uikit";

interface AddCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (name: string) => void;
}
export const AddCategoryModal = defineComponent<AddCategoryModalProps>({
  name: "AddCategoryModal",
  props: ["isOpen", "onClose", "onAdd"],
  setup(props) {
    const { t } = useLocalization();
    const name = ref("");

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      if (name.value.trim()) {
        props.onAdd(name.value.trim());
        name.value = "";
      }
    };

    return () =>
      props.isOpen ? (
        <LemmonModal
          title={t("catalog.modals.add_category_title")}
          onClose={props.onClose}
          renderButtons={() => (
            <div class="p-4 border-t ">
              <div class="flex justify-between gap-2">
                <button onClick={() => props.onClose()} class="btn btn-neutral">
                  {t("general.words.cancel")}
                </button>
                <button
                  onClick={handleSubmit}
                  class="btn btn-primary"
                  disabled={!name.value.trim()}
                >
                  {t("catalog.modals.add_category")}
                </button>
              </div>
            </div>
          )}
        >
          <form onSubmit={handleSubmit} class="p-6">
            <div>
              <label class="block text-sm font-medium  mb-2">
                {t("catalog.modals.category_name")}
              </label>
              <input
                type="text"
                v-model={name.value}
                class="input input-bordered w-full"
                placeholder={t("catalog.modals.category_name_placeholder")}
                autofocus
              />
            </div>
          </form>
        </LemmonModal>
      ) : null;
  },
});
